import { createCookie, getFromQuery } from './util';

export function createCancelCookie(cookieValue) {
  const cookieName = 'cancel';
  document.cookie = `${cookieName}=${cookieValue};domain=aib.pri;hostOnly=false;path=/;secure=yes`;
}

export function loadCookies() {
  createCancelCookie('no');

  const shouldShowLogout = getFromQuery('showLogout');
  if (shouldShowLogout) {
    createCookie('showLogout', shouldShowLogout, 1);
  }

  const returnToValue = getFromQuery('returnTo');
  if (returnToValue) {
    createCookie('returnTo', returnToValue, 1);
  }

  const clientId = getFromQuery('client_id');
  if (clientId) {
    createCookie('clientId', clientId, 1);
  }

  const pacResetFeature = getFromQuery('pacreset');
  if (pacResetFeature) {
    createCookie('pacreset', pacResetFeature, 1);
  }
}

// Setup the aib namespace
const localWindow = window || {};
localWindow.aib = localWindow.aib || {};
const { aib } = localWindow;
aib.regpac = {
  ...aib.regpac,
  createCancelCookie,
  loadCookies,
};
